export const BASE_API_URL = process.env.REACT_APP_API_URL;
export const URL_ACTIVATE_ACCOUNT = 'users/activate';
export const URL_RESET_PASSWORD = 'users/reset-password';
export const URL_GET_ROUTE = 'users/transfers';
